import axios from "axios";
import Config from "@/config"

export default class LoginService {
    generic() {
      const options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      };
      let urlencoded = new URLSearchParams();
      urlencoded.append("grant_type", 'client_credentials');
      urlencoded.append("client_id", Config.env().api.clientId);
      urlencoded.append("scope", "https://graph.microsoft.com/.default");
      urlencoded.append("client_secret", Config.env().api.clientSecret);
      return axios
        .post(
          Config.proxy+Config.env().api.genericLoginUrl,
          urlencoded,
          options
        )
        .then(res => res.data);
    }
    personal(username, password) {
      const options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      };
      let urlencoded = new URLSearchParams();
      urlencoded.append("username", username);
      urlencoded.append("password", password);
      urlencoded.append("client_id", Config.env().api.clientId);
      urlencoded.append("scope", "openid "+Config.env().api.clientId+" offline_access");
      urlencoded.append("grant_type", "password");
      urlencoded.append("response_type", "id_token token");
      return axios
        .post(
          Config.env().api.personalLoginUrl,
          urlencoded,
          options
        )
        .then(res => res.data);
    }
    refresh(refreshToken) {
      const options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      };
      let urlencoded = new URLSearchParams();
      urlencoded.append("client_id", Config.env().api.clientId);
      urlencoded.append("grant_type", "refresh_token");
      urlencoded.append("response_type", "id_token");
      urlencoded.append("resource", Config.env().api.clientId);
      urlencoded.append("refresh_token", refreshToken);
      return axios
        .post(
          Config.env().api.personalLoginUrl,
          urlencoded,
          options
        )
        .then(res => res.data);
    }
}
